import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import close from '../Asset/close.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Form } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { getUserInfo, getDashboard } from './functions/userInfo'
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Imp_Parameters() {
  const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
  let userObj = getUserInfo();
  let tdate = new Date();
  var dd = String(tdate.getDate()).padStart(2, '0');
  var mm = String(tdate.getMonth() + 1).padStart(2, '0');
  var yyyy = tdate.getFullYear();
  let [sessOut, setSessOut] = useState(false);
  let [years, setYears] = useState([]);
  let [today,setToday] = useState(yyyy + "-" + mm + "-" + dd);

  let [filterDefault, setFilterDefault] = useState({
    301: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    302: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    303: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: ""
    },
    304: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    305: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: ""
    },
    306: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    }
  })
  let [filterHis, setFilterHis] = useState({
    301: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    302: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    303: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: ""
    },
    304: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    305: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: ""
    },
    306: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    }
  })
  let [coolLastud, setCoolLastud] = useState("NA");
  let [oilLastud, setOilLastud] = useState("NA");
  let [BatLastud, setBatLastud] = useState("NA");
  let [lastUd, setLastUd] = useState({
    coolent: "",
    oil: "",
    Battery: ""
  });
  
  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    let tempy = [];
    for (let i = 0; i < 3; i++) {
      tempy.push(yyyy - i);
    }
    setYears(tempy);

    if (globObj && globObj != 'undefined') {
      setFilter(globObj);
      saveGlobelFilter('store', globObj);
    }
    else {
      if (dashboard.indexOf(301) >= 0) {
        getCurrentCoolentTemp(filterHis[301]);
      }
      if (dashboard.indexOf(302) >= 0) {
        getAvgMaxCoolentTemp(filterHis[302]);
      }
      if (dashboard.indexOf(303) >= 0) {
        getCurrentOil(filterHis[303]);
      }
      if (dashboard.indexOf(304) >= 0) {
        getAvgMaxOil(filterHis[304]);
      }
      if (dashboard.indexOf(305) >= 0) {
        getCurrentBatteyVolt(filterHis[305]);
      }
      if (dashboard.indexOf(306) >= 0) {
        getAvgMaxBatteyVolt(filterHis[306]);
      }
    }

    getProductCategory();
    getDropDown();
    getSiteList();

    return () => {
      abortController.abort();
    }
  }, [])
  let [siteList, setSiteList] = useState([]);
  let [allAseet, setAllAsset] = useState([]);
  let [curColTemp, setCurColTemp] = useState([]);
  let [colAvgTemp, setColAvgTemp] = useState([]);
  let [curOil, setCurOil] = useState([]);
  let [avgOil, setAvgOil] = useState([]);
  let [curBattery, setCurBattery] = useState([]);
  let [avgBattery, setAvgBattery] = useState([]);
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });

  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);

  let [allpwidth, setAllpwidth] = useState({
    coolTemps: null,
    avgCoolTemps: null,
    oilPressures: null,
    avgOilPressures: null,
    batteryVolts: null,
    avgBatteryVolts: null
  });
  const coolTemp = useRef(null);
  const avgCoolTemp = useRef(null);
  const oilPressure = useRef(null);
  const avgOilPressure = useRef(null);
  const batteryVolt = useRef(null);
  const avgBatteryVolt = useRef(null);
  useEffect(() => {
    let values = {};
    if (coolTemp.current) {
      values.coolTemps = coolTemp.current.offsetWidth;
      values.oilPressures = coolTemp.current.offsetWidth;
      values.batteryVolts = coolTemp.current.offsetWidth;
      //console.log("coolTemp", coolTemp.current.offsetWidth);
    }
    if (avgCoolTemp.current) {
      values.avgCoolTemps = avgCoolTemp.current.offsetWidth;
      values.avgOilPressures = avgCoolTemp.current.offsetWidth;
      values.avgBatteryVolts = avgCoolTemp.current.offsetWidth;
    }

    setAllpwidth(values);
  }, [coolTemp, avgCoolTemp]);

  function getParentWidth() {

  }
  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }
  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {

      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          alert(res.msg);
        }
      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getEquipmentBySite(sid) {
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: sid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setSubCate([]);
    setFilter({
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      fromDate: "",
      toDate: "",
      month: "",
      year: "",
      productCategoryID: "",
      productSubCategoryID: "",
    });
  };
  const handleShow = (dashID) => {
    setFilterDash(dashID);
    setFilter(filterHis[dashID]);
    if (filterHis[dashID].siteID == "" || filterHis[dashID].siteID == undefined) {
      getAssetList();
    }
    else {
      getEquipmentBySite(filterHis[dashID].siteID);
    }
    if (filterHis[dashID].productCategoryID != "") {
      getProductSubCategory(filterHis[dashID].productCategoryID)
    }
    setShow(true);
  }
  function clearFilter(dashID) {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));

    setAllAsset([]);

    if (globObj && globObj != 'undefined') {
      sessionStorage.removeItem('GloberFilter');
      getCurrentCoolentTemp(filterDefault[301]);
      getAvgMaxCoolentTemp(filterDefault[302]);
      getCurrentOil(filterDefault[303]);
      getAvgMaxOil(filterDefault[304]);
      getCurrentBatteyVolt(filterDefault[305]);
      getAvgMaxBatteyVolt(filterDefault[306]);

      setFilterHis({
        301: filterDefault[301],
        302: filterDefault[302],
        303: filterDefault[303],
        304: filterDefault[304],
        305: filterDefault[305],
        306: filterDefault[306]
      });
    }

    else {
      setFilterHis({ ...filterHis, [dashID]: filterDefault[dashID] });
      if (dashID == 301) {
        getCurrentCoolentTemp(filterDefault[301]);
      }
      if (dashID == 302) {
        getAvgMaxCoolentTemp(filterDefault[302]);
      }
      if (dashID == 303) {
        getCurrentOil(filterDefault[303]);
      }
      if (dashID == 304) {
        getAvgMaxOil(filterDefault[304]);
      }
      if (dashID == 305) {
        getCurrentBatteyVolt(filterDefault[305]);
      }
      if (dashID == 306) {
        getAvgMaxBatteyVolt(filterDefault[306]);
      }
    }

    handleClose();
  }

  let [filterDash, setFilterDash] = useState(null);
  let [filter, setFilter] = useState({
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    fromDate: "",
    toDate: "",
    month: "",
    year: "",
    productCategoryID: "",
    productSubCategoryID: ""
  });

  function getFilterData(e) {
    if (e.target.name === "productCategoryID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      getProductSubCategory(parseInt(e.target.value));
    }
    else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      if (e.target.name === "siteID") {
        getEquipmentBySite(e.target.value);
      }
    }
    else if (e.target.name == "fromDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "toDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "month") {
      setFilter({ ...filter, [e.target.name]: e.target.value, year: "", fromDate: "", toDate: "" });
    }
    else if (e.target.name == "year") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", fromDate: "", toDate: "" });
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }

  function getFilterFields() {
    setFilterHis({ ...filterHis, [filterDash]: filter })
    if (filterDash == 301) {
      getCurrentCoolentTemp(filter);
    }
    else if (filterDash == 302) {
      getAvgMaxCoolentTemp(filter);
    }
    else if (filterDash == 303) {
      getCurrentOil(filter);
    }
    else if (filterDash == 304) {
      getAvgMaxOil(filter);
    }
    else if (filterDash == 305) {
      getCurrentBatteyVolt(filter);
    }
    else {
      getAvgMaxBatteyVolt(filter);
    }
  }

  function getCurrentCoolentTemp(obj) {
    fetch(environment.baseUrl + "currentCoolantTemperatureReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.currentCoolantTempurature.forEach((element, index) => {
            if (res.data.currentCoolantThreshold[index][1] > element[1] && res.data.currentCoolantThreshold[index][2] < element[1]) {
              newTemp.push({ 'name': element[0], 'Temperature': element[1], 'fill': "#477508" })//green
            }
            else {
              newTemp.push({ 'name': element[0], 'Temperature': element[1], 'fill': "#8B0000" })
            }
          });
          setCurColTemp(newTemp);
          setCoolLastud(res.data.lastUpdated);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setCurColTemp([])
          setCoolLastud("NA");
        }
        handleClose();
      })
    })
  }

  function getAvgMaxCoolentTemp(obj) {
    fetch(environment.baseUrl + "coolantTempAvgMaxReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
          month: obj.month,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.coolentTempuratureAvgandMax.forEach(element => {
            newTemp.push({ name: element[0], 'Average Temp.': element[1], 'Max Temp.': element[2] })
          });
          setColAvgTemp(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setColAvgTemp([]);
        }
        handleClose();
      })

    })
  }

  function getCurrentOil(obj) {
    fetch(environment.baseUrl + "currentOilPressureReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        equipmentID: obj.equipmentID,
        equipmentType: obj.equipmentType,
        siteID: obj.siteID,
        productCategoryID: obj.productCategoryID,
        productSubCategoryID: obj.productSubCategoryID
      })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.currentOilPressure.forEach((element, index) => {
            if (res.data.currentOilPressureThreshold[index][1] > element[1] && res.data.currentOilPressureThreshold[index][2] < element[1]) {
              newTemp.push({ 'name': element[0], 'Pressure': element[1], 'fill': "#477508" })//green
            }
            else {
              newTemp.push({ 'name': element[0], 'Pressure': element[1], 'fill': "#8B0000" })
            }
          });
          setCurOil(newTemp);
          setOilLastud(res.data.lastUpdated);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setCurOil([]);
          setOilLastud("NA");
        }
        handleClose();
      })
    })
  }

  function getAvgMaxOil(obj) {
    fetch(environment.baseUrl + "avgOilPressureReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
          month: obj.month,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.avgOilPressureReport.forEach(element => {
            newTemp.push({ name: element[0], 'Average Pressure': element[1], 'Max Pressure': element[2] })
          });
          setAvgOil(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAvgOil([]);
        }
        handleClose();
      })
    })
  }

  function getCurrentBatteyVolt(obj) {
    fetch(environment.baseUrl + "currentVoltageReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        equipmentID: obj.equipmentID,
        equipmentType: obj.equipmentType,
        siteID: obj.siteID,
        productCategoryID: obj.productCategoryID,
        productSubCategoryID: obj.productSubCategoryID
      })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.currentVoltageReport.forEach((element, index) => {
            if (res.data.thresholdVoltage[index][1] > element[1]) {
              newTemp.push({ 'name': element[0], 'Voltage': element[1], 'fill': "#8B0000" })
            }
            else {
              newTemp.push({ 'name': element[0], 'Voltage': element[1], 'fill': "#477508" })//green
            }
          });
          setCurBattery(newTemp);
          setBatLastud(res.data.lastUpdated);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setCurBattery([]);
          setBatLastud("NA");
        }
        handleClose();
      })
    })
  }

  function getAvgMaxBatteyVolt(obj) {
    fetch(environment.baseUrl + "avgVoltageReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
        equipmentID: obj.equipmentID,
        equipmentType: obj.equipmentType,
        siteID: obj.siteID,
        dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
        month: obj.month,
        year: obj.year,
        productCategoryID: obj.productCategoryID,
        productSubCategoryID: obj.productSubCategoryID
      })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.avgVoltageReport.forEach(element => {
            newTemp.push({ name: element[0], 'Average Voltage': element[1], 'Max Voltage': element[2] })
          });
          setAvgBattery(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAvgBattery([]);
        }
        handleClose();
      })
    })
  }
  function checkDurFilter(filObj) {
    if (filObj.fromDate != "" || filObj.toDate != "" || filObj.year != "" || filObj.month != "") {
      return true;
    }
    else {
      return false
    }
  }
  function saveGlobelFilter(type, obj) {
    let val = {}, flag = false, filObj;
    if (type == "store") {
      val = obj;
    }
    else {
      sessionStorage.setItem("GloberFilter", JSON.stringify({
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      }));
      val = {
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      };
    }
    flag = checkDurFilter(val);
    filObj = {
      "301": val,
      "302": flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      },
      "303": val,
      "304": flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      },
      "305": val,
      "306": flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      }
    }
    setFilterHis(filObj);
    allApiCall(filObj);
  }
  function allApiCall(req) {
    if (dashboard.indexOf(301) >= 0) {
      getCurrentCoolentTemp(req[301]);
    }
    if (dashboard.indexOf(302) >= 0) {
      getAvgMaxCoolentTemp(req[302]);
    }
    if (dashboard.indexOf(303) >= 0) {
      getCurrentOil(req[303]);
    }
    if (dashboard.indexOf(304) >= 0) {
      getAvgMaxOil(req[304]);
    }
    if (dashboard.indexOf(305) >= 0) {
      getCurrentBatteyVolt(req[305]);
    }
    if (dashboard.indexOf(306) >= 0) {
      getAvgMaxBatteyVolt(req[306]);
    }
  }

  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>Important Parameters</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Important Parameters</p>
      <div className="row">
        <Tabs className='tab-menu' defaultActiveKey="first" id="uncontrolled-tab-example">
          <Tab eventKey="first" title="Coolant Temprature">
            {
              dashboard.indexOf(301) == -1 ? "" :
                <div className="row mt-3 card-box-block">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-6">
                        <h6 className='cardtitle'>Present Coolant Temperature</h6>
                      </div>
                      <div className="col-sm-6  text-end">
                        <i><label className='me-3'>Last Updated :{coolLastud}</label></i>
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(301)} />
                      </div>
                    </div>

                    <hr />
                    <div className='row horizontal-scroll' ref={coolTemp}>
                      {
                        curColTemp.length ?
                          <BarChart
                            width={allpwidth.coolTemps - 30 > curColTemp.length * 130 ? allpwidth.coolTemps - 30 : curColTemp.length * 130}
                            height={300}
                            data={curColTemp}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 10,
                              bottom: 5
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="Temperature" stackId="a" />

                          </BarChart>

                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }
            {
              dashboard.indexOf(302) == -1 ? "" :
                <div className="row card-box-block mt-3">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>Avg. & Max. Coolant Temperature</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(302)} />
                      </div>
                    </div>

                    <hr />
                    <div className='row horizontal-scroll' ref={avgCoolTemp}>
                      {
                        colAvgTemp.length ?

                          <BarChart
                            width={allpwidth.avgCoolTemps - 30 > colAvgTemp.length * 130 ? allpwidth.avgCoolTemps - 30 : colAvgTemp.length * 130}
                            height={300}
                            data={colAvgTemp}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 3
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Average Temp." fill="#0077B9" />
                            <Bar dataKey="Max Temp." fill="#C12065" />
                          </BarChart>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }
          </Tab>
          <Tab eventKey="second" title="Oil Pressure">
            {dashboard.indexOf(303) == -1 ? "" :
              <div className="row card-box-block mt-3">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-6">
                      <h6 className='cardtitle'>Present Oil Pressure</h6>
                    </div>
                    <div className="col-sm-6  text-end">
                      <i><label className='me-3'>Last Updated :{oilLastud}</label></i>
                      <FontAwesomeIcon icon={faBars} onClick={() => handleShow(303)} />
                    </div>
                  </div>

                  <hr />
                  <div className='row horizontal-scroll' ref={oilPressure}>
                    {
                      curOil.length ?
                        <BarChart
                          width={allpwidth.oilPressures - 30 > curOil.length * 130 ? allpwidth.oilPressures - 30 : curOil.length * 130}
                          height={300}
                          data={curOil}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 10,
                            bottom: 5
                          }}
                          barSize={20}
                        >
                          <CartesianGrid vertical={false} strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="Pressure" stackId="a" />
                        </BarChart>
                        :
                        <p className='text-center'><b>No Data Available</b></p>
                    }
                  </div>
                </div>
              </div>
            }
            {
              dashboard.indexOf(304) == -1 ? "" :
                <div className="row card-box-block mt-3">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>Avg. & Max. Oil Pressure</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(304)} />
                      </div>
                    </div>

                    <hr />
                    <div className='row horizontal-scroll' ref={avgOilPressure}>
                      {
                        avgOil.length ?

                          <BarChart
                            width={allpwidth.avgOilPressures - 30 > avgOil.length * 130 ? allpwidth.avgOilPressures - 30 : avgOil.length * 130}
                            height={310}
                            data={avgOil}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 10
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Average Pressure" fill="#0077B9" />
                            <Bar dataKey="Max Pressure" fill="#C12065" />
                          </BarChart>

                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }
          </Tab>
          <Tab eventKey="third" title="Battery Voltage">
            {
              dashboard.indexOf(305) == -1 ? "" :
                <div className="row card-box-block mt-3">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-6">
                        <h6 className='cardtitle'>Present Battery Voltage</h6>
                      </div>
                      <div className="col-sm-6  text-end">
                        <i><label className='me-3'>Last Updated :{BatLastud}</label></i>
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(305)} />
                      </div>
                    </div>

                    <hr />
                    <div className='row horizontal-scroll' ref={batteryVolt}>
                      {
                        curBattery.length ?

                          <BarChart
                            width={allpwidth.batteryVolts - 30 > curBattery.length * 130 ? allpwidth.batteryVolts - 30 : curBattery.length * 130}
                            height={300}
                            data={curBattery}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 10,
                              bottom: 5
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="Voltage" stackId="a" />
                          </BarChart>

                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }
            {
              dashboard.indexOf(306) == -1 ? "" :
                <div className="row card-box-block mt-3">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>Avg. & Max. Battery Voltage</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(306)} />
                      </div>
                    </div>

                    <hr />
                    <div className='row horizontal-scroll' ref={avgBatteryVolt}>
                      {
                        avgBattery.length ?
                          <BarChart
                            width={allpwidth.avgBatteryVolts - 30 > avgBattery.length * 130 ? allpwidth.avgBatteryVolts - 30 : avgBattery.length * 130}
                            height={310}
                            data={avgBattery}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 3
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Average Voltage" fill="#0077B9" />
                            <Bar dataKey="Max Voltage" fill="#C12065" />
                          </BarChart>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }
          </Tab>
        </Tabs>
      </div>
      {/* ///////////////////////////////////////////////// */}
      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title> Filters</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className='row'>
            {
              filterDash == 302 || filterDash == 304 || filterDash == 306 ?
                <>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>From Date</Form.Label>
                      <Form.Control type='date' placeholder='fromDate' name='fromDate' value={filter.fromDate} max={today}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>To Date</Form.Label>
                      <Form.Control type='date' placeholder='toDate' name='toDate' value={filter.toDate} min={filter.fromDate} max={today}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>Month</Form.Label>
                      <Form.Control type='month' placeholder='Month' name='month' value={filter.month}
                        className="textbox-back" onChange={getFilterData} max={yyyy+"-"+mm} />
                    </Form.Group>
                  </div>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2 " >
                      <Form.Label>Year</Form.Label>
                      <Form.Select as='select' placeholder='year' name='year' value={filter.year}
                        className="textbox-back" onChange={getFilterData}>
                        <option value="">Select Year</option>
                        {
                          years.map((item, index) =>
                            <option key={index} value={item}>{item}</option>
                          )
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>
                </>
                :
                ""
            }
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <label>Equipment ID</label>
                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>

              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={() => clearFilter(filterDash)}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>

    </div>
  )
}

export default Imp_Parameters
